import { PartBomListPage } from 'partBoms/pages';

import { partBomListPath } from './routePaths';

export const partBoms = {
  path: partBomListPath(),
  exact: true,
  isPrivate: true,
  element: <PartBomListPage />,
};
